import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_status_pip_resize",
  "use": "icon-icon_status_pip_resize-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" overflow=\"visible\" id=\"icon-icon_status_pip_resize\">\n<path fill-rule=\"evenodd\" stroke=\"#000000\" d=\"M17.5,0.5h-4v13h-13v4h17V0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol